import { Button, Form, Input, message } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../app/hooks';
import { ISetState } from '../../../../common/types/commonTypes';
import { selectCommon, setModal } from '../../../../common/slices/commonSlice';
import { DesignationDataType } from '../types/designationTypes';
import { useEditDesignationMutation } from '../endpoints/designationEndpoints';
import assyncWrapper from '../../../../common/utils/assyncWrapper';
import LoadingIndicator from '../../../../components/common/spinner/LoadingIndicator';

interface IProps {
  designationNameList: string[];
  info: DesignationDataType;
  setNull: ISetState<DesignationDataType | null>;
}
const DesignationEditModal = ({
  info,
  setNull,
  designationNameList,
}: IProps) => {
  const dispatch = useAppDispatch();

  const [input, setInput] = useState<DesignationDataType>(info);

  const modalSlice = useSelector(selectCommon);

  const [form] = Form.useForm();

  useEffect(() => {
    setInput(info);
  }, [info]);

  useEffect(() => {
    form.setFieldsValue({
      designation_name: input.designation_name,
    });
  }, [input]);

  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 16 },
  };

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const [editDesignation, { isError, isSuccess, isLoading }] =
    useEditDesignationMutation();
  useEffect(() => {
    if (isSuccess) {
      message.success('Designation Added Successfully');
    } else if (isError) {
      message.error('Something went wrong');
    }
  }, [isSuccess, isError]);
  const handleSubmit = async () => {
    assyncWrapper(async () => {
      const values = (await form.getFieldsValue()) as DesignationDataType;
      values.designation_id = info.designation_id;
      await editDesignation({ ...values });
      setNull(null);
      dispatch(setModal(false));
    });
  };

  return (
    <div>
      <Form
        labelAlign='left'
        {...layout}
        onFinish={handleSubmit}
        validateMessages={validateMessages}
        form={form}
      >
        <Form.Item
          name='designation_name'
          label='Enter Designation Name: '
          rules={[
            { required: true, message: 'Please input Designation name!' },
            { max: 65, message: 'Maximum 65 characters' },
            {
              validator(_, value) {
                if (value) {
                  if (designationNameList.includes(value)) {
                    return Promise.reject('Designation Name is already Exist');
                  } else {
                    return Promise.resolve();
                  }
                } else {
                  return Promise.resolve();
                }
              },
            },
          ]}
        >
          <Input placeholder='Edit designation name' />
        </Form.Item>

        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 9 }}>
          <Button
            disabled={modalSlice.modalLoading}
            type='primary'
            htmlType='submit'
            loading={isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
      {isLoading && <LoadingIndicator />}
    </div>
  );
};

export default DesignationEditModal;
